import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const CreditsAlt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M7.30078 0C9.89638 0.000130182 12 2.10434 12 4.7002C12 6.12001 11.3696 7.38895 10.376 8.24902C10.4915 7.80846 10.5537 7.34597 10.5537 6.86914C10.5537 6.7274 10.5454 6.57728 10.5371 6.43555C10.3285 3.79078 8.20995 1.67158 5.56543 1.46289C5.42376 1.45456 5.27352 1.44631 5.13184 1.44629C4.65476 1.44629 4.19175 1.50834 3.75098 1.62402C4.61099 0.630167 5.88096 0 7.30078 0Z"
      fill="white"
    />
    <path
      d="M9.735 6.735C9.5475 4.3575 7.6425 2.4525 5.265 2.265C5.1375 2.2575 5.0025 2.25 4.875 2.25C2.1825 2.25 0 4.4325 0 7.125C0 9.8175 2.1825 12 4.875 12C7.5675 12 9.75 9.8175 9.75 7.125C9.75 6.9975 9.7425 6.8625 9.735 6.735ZM5.535 7.785L4.875 9L4.215 7.785L3 7.125L4.215 6.465L4.875 5.25L5.535 6.465L6.75 7.125L5.535 7.785Z"
      fill="white"
    />
  </svg>
)

export default withDefaultStyles(CreditsAlt)
